import React from "react";
import VideoFeed from "../components/VideoFeed";

function Home() {
  return (
    <div style={{ position:"fixed", inset:0, background:"#000" }}>
      <VideoFeed />
    </div>
  );
}

export default Home;
